import React from 'react';
import Layout from '../layout';
import AnalyticsDashboard from './AnalyticsDashboard';

const AnalyticsPage: React.FC = () => {
  return (
    <Layout components={[<AnalyticsDashboard key="analytics-dashboard" />]} />
  );
};

export default AnalyticsPage; 